<template>
  <div class="menus">
    <v-row align="center" style="margin: 0 !important">
      <v-col
        align="center"
        v-for="item in categories"
        :key="item.Name"
        cols="4"
        sm="3"
        lg="2"
        class="menuCol"
      >
        <v-btn class="btn-menus" fab @click="$emit('click', item)">
          <div>
            <font-awesome-icon
              :icon="item.Icon"
              class="menuIcon"
              size="2x"
              :color="'#' + item.Color"
            />
          </div>
          <span class="menuTitle" :style="[{ color: '#5c5c5c' }]">{{
            item.Title
          }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["categories"],
};
</script>

<style>
.menus {
  width: 100%;
  min-height: calc(100vh - 80px);
  position: absolute;
}
</style>
